import { useBoolean } from 'ahooks';
import { useUserLoggedIn } from '~/modules/user';
import LoginSignUpModal from '@modules/user/component/login-signup-modal/LoginSignUpModal';
import { useVariantSelectionState } from '@modules/product/context/VariantSelectionContext';
import type Product from '@modules/product/type/product';
import type { VariantPriceType } from '@modules/product/util/get-variant-price';

const getSpecialtyPriceText = (
    product: Product,
    priceType?: VariantPriceType
): string | null => {
    switch (priceType) {
        case 'TradeProduct':
            return 'Trade discount applied';
        case 'SpecialtyPricedTradeProduct':
            return product.SpecialtyTradePriceText ?? null;
        case 'CustomerProduct':
            return product.SpecialtyCustomerPriceText ?? null;
    }
    return null;
};

const SpecialtyPricingBanner = ({ product }: { product: Product }) => {
    const { isLoggedIn } = useUserLoggedIn();
    const { selectedVariant } = useVariantSelectionState();
    const [showSignIn, setShowSignIn] = useBoolean();

    const bannerText = isLoggedIn
        ? getSpecialtyPriceText(product, selectedVariant?.SpecialtyPriceType)
        : product.SpecialtyBannerText;
    if (!bannerText) {
        return null;
    }

    return (
        <>
            <div className="bg-gray-100 p-3 text-center text-sm md:p-4 md:text-base">
                {!isLoggedIn && (
                    <>
                        <span
                            className="cursor-pointer underline"
                            onClick={setShowSignIn.setTrue}
                        >
                            Sign in or create an account
                        </span>{' '}
                    </>
                )}
                {bannerText}
            </div>
            <LoginSignUpModal
                login={{
                    open: showSignIn,
                    onCancel: setShowSignIn.setFalse,
                    onConfirm: setShowSignIn.setFalse,
                    onAuthSuccess: setShowSignIn.setFalse,
                    flow: null,
                    authSource: 'specialtyPricingBanner',
                }}
                forgotPassword={{
                    open: showSignIn,
                    onCancel: setShowSignIn.setFalse,
                }}
            />
        </>
    );
};
export default SpecialtyPricingBanner;
